/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Mesh, PerspectiveCamera, Vector3 } from 'three';
import { Ticker } from '~/Chrono';
import { GetVisibleAngle, VisibleAngle } from '~/Direction';
import { SignalDispatch } from '~/Signal';
import { SetUvMap } from '~/Component/UvMap';
import { TextureData } from '~/Component/Texture';

import { Actor } from './Types';
import { ActorAddSignal, ActorRemoveSignal } from './Signals';
import { CameraGet, CameraGetDirection } from '~/Camera';

/*
|--------------------------------------------------------------------------
| Locals
|--------------------------------------------------------------------------
*/

let _actors: Array<Actor> = [];
let _camera: PerspectiveCamera = null;
let _actorLookAt: Vector3 = null;

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {void}
 */
export function ActorAdd(mesh: Mesh, uvMap: TextureData, facing?: Vector3, visible?: VisibleAngle): void
{
    let actor: Actor = {
        mesh,
        uvMap,
        facing: facing ?? new Vector3(0, 0, 1),
        visible: visible ?? VisibleAngle.Front,
        active: true,
    };

    _actors.push(actor);
    SignalDispatch<ActorAddSignal>('ActorAdd', { target: actor });
}

/**
 * @return {void}
 */
export function ActorUpdate(ticker: Ticker): void
{
    let index = _actors.length;

    while (index--) {
        let actor = _actors[index];

        if (actor.active) {
            actor.mesh.quaternion.identity();

            let visible = GetVisibleAngle(actor.mesh, _camera.position);

            if (visible !== actor.visible) {
                actor.visible = visible;
                SetUvMap(actor.mesh.geometry, actor.uvMap, `Ettin-Walk1-${visible}`);
            }

            _actorLookAt.copy(actor.mesh.position);
            _actorLookAt.add(CameraGetDirection());
            _actorLookAt.y = actor.mesh.position.y;

            actor.mesh.lookAt(_actorLookAt);
        } else {
            _actors.splice(index, 1);
            SignalDispatch<ActorRemoveSignal>('ActorRemove', { target: actor });
        }
    }
}

/**
 * @return {void}
 */
export function ActorInit(): void
{
    _camera = CameraGet();
    _actorLookAt = new Vector3;
}
